import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type {
  BookingFlow,
  InterstitialVariant,
} from "~/services/booking-flows";
import { safeStorage } from "~/shared/utils/safeStorage";

type BookingFlowStore = {
  flow: BookingFlow | null;
  isProviderView: boolean;
  isNirvanaEnabled: boolean;
  interstitialVariant: InterstitialVariant | null;
  interstitialGoals: string[];
  setIsProviderView: (value: boolean) => void;
  setIsNirvanaEnabled: (value: boolean) => void;
  setInterstitialVariant: (value: InterstitialVariant | null) => void;
  setInterstitialGoals: (value: string[]) => void;
  start: (flow: BookingFlow) => void;
  clear: VoidFunction;
  flowInProgress: () => boolean;
};

export const useBookingFlowStore = create<BookingFlowStore>()(
  persist(
    (set, get) => ({
      flow: null,
      isProviderView: true,
      isNirvanaEnabled: false,
      interstitialVariant: null,
      interstitialGoals: [],

      setIsProviderView: (value) =>
        set({
          isProviderView: value,
        }),

      setIsNirvanaEnabled: (value) =>
        set({
          isNirvanaEnabled: value,
        }),

      setInterstitialVariant: (value) =>
        set({
          interstitialVariant: value,
        }),

      setInterstitialGoals: (value) =>
        set({
          interstitialGoals: value,
        }),

      start: (flow) =>
        set({
          flow,
        }),

      clear: () => {
        set({
          isNirvanaEnabled: false,
          interstitialVariant: null,
          interstitialGoals: [],
        });

        if (get().flowInProgress()) {
          set({
            flow: null,
          });
        }
      },

      flowInProgress: () => !!get().flow,
    }),
    {
      name: "booking-flow-store",
      storage: createJSONStorage(() => safeStorage),
    },
  ),
);
